import { APIS } from '../../_config'
import { createAgentSaga } from './createAgentSaga'

const saga = createAgentSaga(APIS.DEVOPS_AGENT, 'DevOps Agent')

export const { createSession, chat, listSessions, getSessionMessages, deleteSession, submitFeedback } = saga
